import { Card, Form, Spin, Tag, Input, AutoComplete, Select } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import UsersTable from "../../components/user/UsersTable";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { handleError } from "../../utils/ErrorHandlers";
import { FileService } from "../../services/file/FileService";
import { Translation } from "react-i18next";
import i18next from "i18next";
import Page from "../general/Page";
import "./ViewGroup.css";
class ViewGroup extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("viewGroups");
    this.fileService = new FileService();
    this.acc = new AccountGroupService();

    this.state = {
      userId: "",
      visible: false,
      groupAccount: {},
      isFetching: true,
      formLayout: "inline",
      loading: false,
      callFlowsList: [],
      selectedValueCallFlowId: "",
      callFlowName: "",
      groupNumbers: "",
      viewNumberOfConcurrentCalls: "",
      readyFlow: "",
      agentNumberForAgentGroup: "",
      agentNumberOfConcCalls: 0,
      activateVoiceMail: "false",
      startHour: "",
      endHour: "",
      voiceMailMessage: "",
      workingDays: "",
    };
  }

  async componentDidMount() {
    try {
      let {
        groupAccount,
        cfg,
        viewNumberOfConcurrentCalls,
        selectedValueCallFlowId,
        groupNumbers,
        selectedValueSM,
        readyFlow,
        agentNumberForAgentGroup,
        agentNumberOfConcCalls,
        activateVoiceMail,
        startHour,
        endHour,
        voiceMailMessage,
        workingDays,
      } = this.state;
      this.setState({ isFetching: true });

      let groupAccountResponse = await this.getGroupData();
      cfg = groupAccountResponse.cfg;

      groupAccount = groupAccountResponse;

      cfg.forEach((element) => {
        if (
          Object.getOwnPropertyNames(element).indexOf("MAX_CONCURRENT_CALLS") >
          -1
        ) {
          viewNumberOfConcurrentCalls = element["MAX_CONCURRENT_CALLS"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("CALL_FLOW") > -1) {
          selectedValueCallFlowId = element["CALL_FLOW"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("GROUP_NUMBERS") > -1) {
          groupNumbers = element["GROUP_NUMBERS"].split(",");
        }
        if (Object.getOwnPropertyNames(element).indexOf("SWITCH_MODE") > -1) {
          selectedValueSM = element["SWITCH_MODE"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("READY_FLOW") > -1) {
          readyFlow = element["READY_FLOW"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("AGENTS_NUMBERS") > -1
        ) {
          agentNumberForAgentGroup = element["AGENTS_NUMBERS"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("MAX_CONCURRENT_CALLS") >
          -1
        ) {
          agentNumberOfConcCalls = element["MAX_CONCURRENT_CALLS"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("ACTIVATE_VOICEMAIL") > -1
        ) {
          activateVoiceMail = element["ACTIVATE_VOICEMAIL"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("END_WORKING_HOUR") > -1
        ) {
          endHour = element["END_WORKING_HOUR"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("START_WORKING_HOUR") > -1
        ) {
          startHour = element["START_WORKING_HOUR"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("VOICEMAIL_PROMPT") > -1
        ) {
          voiceMailMessage = element["VOICEMAIL_PROMPT"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("WORKING_DAYS") > -1) {
          workingDays = element["WORKING_DAYS"];
        }
      });
      this.setState({
        cfg,
        groupAccount,
        selectedValueCallFlowId,
        selectedValueSM,
        viewNumberOfConcurrentCalls,
        groupNumbers,
        readyFlow,
        agentNumberForAgentGroup,
        agentNumberOfConcCalls,
        activateVoiceMail,
        startHour,
        endHour,
        voiceMailMessage,
        workingDays,
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  async getGroupData() {
    let { id } = this.props.match.params;

    try {
      let response = await this.acc.getGroupByAccountIdAndGroupIdService(
        this.props.context.session_id,
        id
      );
      return response.ivrCustomEntityObject;
    } catch (e) {
      throw e;
    }
  }
  mapWorkingDays(items) {
    items = items.split(",");
    let days = [];
    items.forEach((index) => {
      switch (index) {
        case "0":
          days.push(i18next.t("Sunday"));
          break;
        case "1":
          days.push(i18next.t("Monday"));
          break;
        case "2":
          days.push(i18next.t("Tuesday"));
          break;
        case "3":
          days.push(i18next.t("Wednesday"));
          break;
        case "4":
          days.push(i18next.t("Thursday"));
          break;
        case "5":
          days.push(i18next.t("Friday"));
          break;
        case "6":
          days.push(i18next.t("Saturday"));
          break;
        default:
          break;
      }
    });

    return days.toString();
  }
  mapSwitchModes(mode) {
    switch (mode) {
      case "0":
        return "Round Robin";
      case "1":
        return "Most Idle Time";
      case "2":
        return "Least Received Calls";
      default:
        break;
    }
  }
  render() {
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const { Option } = Select;
    const { getFieldDecorator } = this.props.form;
    let {
      groupAccount,
      readyFlow,
      agentNumberForAgentGroup,
      agentNumberOfConcCalls,
      selectedValueCallFlowId,
      activateVoiceMail,
      startHour,
      endHour,
      voiceMailMessage,
      workingDays,
      isFetching,
    } = this.state;

    // workingDays = this.mapWorkingDays(workingDays);
    return (
      <Translation>
        {(t) => (
          <Page title={t("View Group")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Form.Item label={t("Group Name")} {...formItemLayout}>
                      <label>{groupAccount.groupName} </label>
                    </Form.Item>

                    <Form.Item label={t("Group Status")} {...formItemLayout}>
                      {groupAccount.groupStatus === "ACT" ? t("ACT") : null}
                      {groupAccount.groupStatus === "INT" ? t("INT") : null}
                      {groupAccount.groupStatus === "SUS" ? t("SUS") : null}
                    </Form.Item>

                    <Form.Item label={t("Group Type")} {...formItemLayout}>
                      {groupAccount.groupType === "SXG" ? t("Agent") : null}
                      {groupAccount.groupType === "IBG" ? t("Inbound") : null}
                    </Form.Item>
                    {groupAccount.groupType === "IBG" ? (
                      <div>
                        <Form.Item
                          label={t("Number Of Concurrent Calls")}
                          {...formItemLayout}
                        >
                          {this.state.viewNumberOfConcurrentCalls}
                        </Form.Item>

                        <Form.Item
                          label={t("Group Numbers")}
                          {...formItemLayout}
                        >
                          <div>
                            {this.state.groupNumbers.map((tag, index) => {
                              return <Tag key={tag}>{tag}</Tag>;
                            })}
                          </div>
                        </Form.Item>

                        <Form.Item label={t("Call Flow")} {...formItemLayout}>
                          <label>{t(selectedValueCallFlowId)}</label>
                        </Form.Item>
                        <Form.Item label={t("Ready Flow")} {...formItemLayout}>
                          <label>
                            {readyFlow === "None" ? t("None") : t(readyFlow)}
                          </label>
                        </Form.Item>
                        {activateVoiceMail === "true" ? (
                          <div>
                            <Form.Item
                              label={t("Activate VoiceMail")}
                              {...formItemLayout}
                            >
                              <label>{t(activateVoiceMail)}</label>
                            </Form.Item>
                            <Form.Item
                              label={t("Start Working Hour")}
                              {...formItemLayout}
                            >
                              <label>{startHour}</label>
                            </Form.Item>
                            <Form.Item
                              label={t("End Working Hour")}
                              {...formItemLayout}
                            >
                              <label>{endHour}</label>
                            </Form.Item>
                            <Form.Item
                              label={t("Working Days")}
                              {...formItemLayout}
                            >
                              <label>{this.mapWorkingDays(workingDays)}</label>
                            </Form.Item>
                            <Form.Item
                              label={t("VoiceMail Message")}
                              {...formItemLayout}
                            >
                              <label>{voiceMailMessage}</label>
                            </Form.Item>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <div>
                        {/* <Form.Item label="Agent Number" {...formItemLayout}>
                        <label>{agentNumberForAgentGroup}</label>
                      </Form.Item> */}
                        <Form.Item label={t("Switch Mode")} {...formItemLayout}>
                          <label>
                            {t(this.mapSwitchModes(this.state.selectedValueSM))}
                          </label>
                        </Form.Item>
                        {this.state.groupAccount.groupType === "IBG" && (
                          <Form.Item
                            label={t("Number Of Concurrent Calls")}
                            {...formItemLayout}
                          >
                            <label>{agentNumberOfConcCalls}</label>
                          </Form.Item>
                        )}
                      </div>
                    )}
                  </Form>
                </Card>

                {this.state.groupAccount.groupType === "SXG" ? (
                  <UsersTable
                    groupId={this.props.match.params}
                    onRefresh={() => this.getGroupData()}
                  ></UsersTable>
                ) : null}
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(withSharedStateConsumer(withRouter(ViewGroup)));
